import FEEDBACK_CONSTANTS from '@/constants/feedbackConstants';

export default {
  heading: 'Obrigado pela sua avaliação!',
  text: 'Há algo que possamos melhorar? Partilhe a sua opinião connosco.',
  form: {
    fields: [
      {
        type: 'textarea',
        name: FEEDBACK_CONSTANTS.FEEDBACK_NAME,
        placeholder: 'A sua opinião...'
      }
    ],
    submit: {
      label: 'Enviar'
    }
  }
};